import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IDwUsersActivityGeolocation, IDwUsersActivityPayload, IDwUsersActivityResponse } from '../models/dwUsersActivity';
import { HttpClient } from '@angular/common/http';
import { DwUserActivityTypes } from '../models/dwUsersActivityTypes';
import { DwUserActivityNames } from '../models/dwUserActivityNames';
import { SessionService } from './session.service';
import { TariffPlans } from '../models/tariffPlans';

const ROOT_URL: string = '/api/mix-panel/';

@Injectable({
	providedIn: 'root'
})
export class DwUsersActivityService {

	private _geoLocation: IDwUsersActivityGeolocation;

	static getBrowserName(): string {
		const regexps = {
			'Chrome': [/Chrome\/(\S+)/],
			'Firefox': [/Firefox\/(\S+)/],
			'MSIE': [/MSIE (\S+);/],
			'Opera': [/Opera\/.*?Version\/(\S+)/, /Opera\/(\S+)/],
			'Safari': [/Version\/(\S+).*?Safari\//]
		};

		const userAgent = window.navigator.userAgent;
		const elements = 1;

		const browserMatch = Object.entries(regexps).find(([_, regexList]) =>
			regexList.some(re => userAgent.match(re))
		);

		if (browserMatch) {
			const [browser, regexList] = browserMatch;
			const matchedRegex = regexList.find(re => userAgent.match(re))!;
			const versionMatch = userAgent.match(matchedRegex);

			if (versionMatch) {
				const version = versionMatch[1]
					.match(new RegExp(`[^.]+(?:.[^.]+){0,${elements}}`))![0];
				return `${browser} ${version}`;
			}
		}

		return 'unknown';
	}

	constructor(private http: HttpClient, private sessionService: SessionService) {}

	private _sendActivity(data: IDwUsersActivityPayload): Observable<IDwUsersActivityResponse> {
		return this.http.post<IDwUsersActivityResponse>(ROOT_URL, data);
	}

	geolocationInitialize(): void {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition((position: GeolocationPosition) => {
				this._geoLocation = {
					latitude: position.coords.latitude,
					longitude: position.coords.longitude
				}
			});
		}
	}

	track(activityName: DwUserActivityNames, activityType: DwUserActivityTypes): void {
		const avoidTariffs: Array<TariffPlans> = [TariffPlans.Demo];
		if (avoidTariffs.includes(this.sessionService.defaults.tariff_plan?.name)) return;
		if (this.sessionService.isFramePage) return;

		const payload: IDwUsersActivityPayload = {
			activity_type: activityType,
			browser_name: DwUsersActivityService.getBrowserName(),
			date: new Date().toLocaleString('sv'),
			latitude: this._geoLocation?.latitude,
			longitude: this._geoLocation?.longitude,
			payload: {},
			report_name: activityName,
			screen_height: window.outerHeight,
			screen_width: window.outerWidth
		}
		this._sendActivity(payload).subscribe();
	}
}
